import React, { useContext } from 'react';
import BoardsContext from '../../../contexts/BoardsContext';
import FeatureGatesContext from '../../../contexts/FeatureGatesContext';
import useBoards from '../../../hooks/useBoards';

const NO_BOARDS = { boards: [], archivedBoards: [] };

// Always wraps the children, loading boards only while the performance gate
// is open. The gate opens once the account's feature gates load, after this
// has mounted, so adding the provider only then would remount everything below.
const BoardsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { isPerformanceEnabled } = useContext(FeatureGatesContext);
  const { boards, archivedBoards } = useBoards({
    isEnabled: isPerformanceEnabled,
  });

  return (
    <BoardsContext.Provider
      value={isPerformanceEnabled ? { boards, archivedBoards } : NO_BOARDS}
    >
      {children}
    </BoardsContext.Provider>
  );
};

export default BoardsProvider;
